import React from 'react';
import TableSearch from "@/components/table/tableSearch";
import {URLS} from "@/lib/urls";
import {Button} from "antd";
import {Can, hasPermissionLink} from "@/components/can/Can";
import PermList from "@/lib/helper/PermList";
import {Link, useNavigate} from "react-router-dom";
import AdminLayout from "@/components/layout/admin/adminLayout";
import {sprintf} from "@/lib/utils/sprintf";
import {useApiSearchAdminGrades} from "@/api/grade";
import GradeStatusEnumComponent from "@/components/EnumComponents/GradeStatusEnumComponent";
import SignupStatusEnumComponent from "@/components/EnumComponents/SignupStatusEnumComponent";

export default function AdminGradeListPage(props) {
    const navigate = useNavigate();

    const columns = [
        {
            title: 'شناسه',
            dataIndex: 'id',
            key: 'id',
            width: 75,
            align: 'center',
            responsive: ['sm'],
        },
        {
            title: 'عنوان گروه',
            dataIndex: 'title',
            key: 'title',
            width: 220,
            ellipsis: true,
        },
        {
            title: 'حداقل سن',
            dataIndex: 'minage',
            key: 'minage',
            width: 100,
            align: 'center',
            render: (minage) => (
                minage ? `${minage} سال` : '-'
            ),
            responsive: ['md'],
        },
        {
            title: 'ثبت‌نام',
            dataIndex: 'signup',
            key: 'signup',
            width: 110,
            align: 'center',
            render: (signup) => (
                <SignupStatusEnumComponent text={signup} />
            ),
        },
        {
            title: 'وضعیت',
            dataIndex: 'status',
            key: 'status',
            width: 110,
            align: 'center',
            render: (status) => (
                <GradeStatusEnumComponent text={status}/>
            ),
        },
        {
            title: 'توضیحات',
            dataIndex: 'desc',
            key: 'desc',
            ellipsis: true,
            responsive: ['lg'],
            render: (desc) => desc || '-',
        },
        {
            title: 'عملیات',
            dataIndex: 'id',
            key: 'actions',
            width: 100,
            fixed: 'right',
            align: 'center',
            render: (_, record) => (
                <Link
                    to={hasPermissionLink(
                        PermList.GRADE_EDIT,
                        sprintf(URLS.admin.grade.edit, { id: record.id })
                    )}
                >
                    <Button size="small" variant="outlined" color="default">
                        مشاهده
                    </Button>
                </Link>
            ),
        },
    ];

    return (
        <>
            <AdminLayout pageTitle={'مقاطع تحصیلی'} backTo={URLS.admin.setting.dashboard}>
                <TableSearch
                    searchInput={true}
                    addButton={
                        <div className={'flex justify-end gap-1'}>
                            <Can permission={PermList.GRADE_CREATE}>
                                <Button
                                    color={'primary'}
                                    variant={'solid'}
                                    size={'middle'}
                                    onClick={() => navigate(URLS.admin.grade.create)}>
                                    افزودن مقطع تحصیلی

                                </Button>
                            </Can>


                        </div>
                    }
                    apiFn={useApiSearchAdminGrades}
                    columns={columns}
                    scroll={{x: true}}
                    responsive={true}
                />
            </AdminLayout>
        </>
    );
}